import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets//images/logo.png'
import _imports_1 from '../assets/images/zhanghao.png'
import _imports_2 from '../assets/images/passw.png'
import _imports_3 from '../assets//images/showp.png'
import _imports_4 from '../assets//images/unshow.png'
import _imports_5 from '../assets/images/pulldown.png'
import _imports_6 from '../assets/images/packup.png'
import _imports_7 from '../assets/images/lan.png'
import _imports_8 from '../assets/images/cars.png'


const _withScopeId = n => (_pushScopeId("data-v-7aea9de7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logoImg",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = { class: "login" }
const _hoisted_3 = { class: "login-main-box" }
const _hoisted_4 = { class: "main-box-title" }
const _hoisted_5 = { class: "login-main-box-form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "frontImg",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "frontImg",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_8 = {
  key: 0,
  src: _imports_3,
  alt: ""
}
const _hoisted_9 = {
  key: 1,
  src: _imports_4,
  alt: ""
}
const _hoisted_10 = {
  key: 0,
  class: "selectImg",
  src: _imports_5,
  alt: ""
}
const _hoisted_11 = {
  key: 1,
  class: "selectImg",
  src: _imports_6,
  alt: ""
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "lanImg",
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "bottom" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "foot" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "lastImg",
  src: _imports_8,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.t("wxb")), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.loginObj.username,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginObj.username) = $event)),
                    placeholder: _ctx.t('pleaseenteraccountnumber'),
                    clearable: ""
                  }, {
                    prefix: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["value", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_password, {
                    value: _ctx.loginObj.password,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginObj.password) = $event)),
                    placeholder: _ctx.t('inputpassword'),
                    "show-password": ""
                  }, {
                    prefix: _withCtx(() => [
                      _hoisted_7
                    ]),
                    iconRender: _withCtx((v) => [
                      v
                        ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                        : (_openBlock(), _createElementBlock("img", _hoisted_9))
                    ]),
                    _: 1
                  }, 8, ["value", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    class: "select",
                    value: _ctx.lanValue,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lanValue) = $event)),
                    options: _ctx.options,
                    onChange: _ctx.handleChangeLan,
                    onDropdownVisibleChange: _ctx.dropdownVisibleChange
                  }, {
                    suffixIcon: _withCtx(() => [
                      (!_ctx.isUp)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                        : _createCommentVNode("", true),
                      (_ctx.isUp)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                        : _createCommentVNode("", true),
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["value", "options", "onChange", "onDropdownVisibleChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { class: "loginBtn" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    onClick: _ctx.loginF,
                    class: "button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("login")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t("makecleaningeasy")), 1),
          _createElementVNode("div", _hoisted_15, "Copyright © " + _toDisplayString(_ctx.t("corporation")), 1)
        ]),
        _hoisted_16
      ])
    ])
  ], 64))
}